import NetworkUtil from "./NetworkUtil";
import Facility, {FacilitySearch} from "../types/Facility";
import {ServerResponse} from "../types/ServerResponse";

export class FacilityAPI{

    public static facilitySearch(filter, page):Promise<{num_pages:number, table_data?:FacilitySearch[],  data:FacilitySearch[]}>{
        return NetworkUtil.makePost("/api/admin/searchFacility?page=" + page, filter);
    }

    public static facilityUpsert(facility:Facility):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/facilityUpsert", {facility: facility});
    }

    // after PaymentAPI.createCustomerProfile() we FacilityAPI.addANetProfileToFacility
    public static addANetCustomerProfileIDs({facilityID, aNetIDs}):Promise<{success:boolean,reason:string,data:Facility}>{
        return NetworkUtil.makePost("/api/admin/addANetProfileToFacility", {facilityID: facilityID, aNetIDs: aNetIDs});
    }

    // Rotates the GCP-managed API key used by the inbound HL7 API for this facility.
    // Hard cut: old key becomes invalid at the function-layer lookup the moment the response returns.
    // The plaintext apiKey is returned exactly once — display it to the user, then forget it.
    public static rotateAPIKey(facilityID:number):Promise<{success:boolean, apiKey?:string, apiKeyFingerprint?:string, createdDate?:string, reason?:string}>{
        return NetworkUtil.makePost("/api/admin/facility/apiKey/rotate", {facilityID: facilityID});
    }
}
